module.exports = __webpack_public_path__ + "img/what_you_do.aa6e0825.svg";